import { gql, InMemoryCache } from '@apollo/client'
import getDoc from './get-doc'
import { variableToString } from '@wolfdanepug/common-react'

const readField =
	(field: string) =>
	(existing: any, { args }: any) => {
		if (!args) return existing
		const { offset, limit /* filter, sortAttribute, sortDirection*/ } = args
		// Logger.log('%s:read', field, { existing, offset, limit, filter, sortAttribute, sortDirection })
		return existing
			? { items: existing.items.slice(offset, offset + limit), limit, offset }
			: existing
	}

const mergeField =
	(field: string) =>
	(
		existing: any,
		incoming: any,
		{ args: { offset = 0, limit, filter, sortAttribute, sortDirection } }: any
	) => {
		const merged = existing ? existing.items.slice(0) : []
		const newItems = incoming.items.length

		for (let i = 0; i < newItems; ++i) {
			merged[offset + i] = incoming.items[i]
		}
		return {
			size: limit,
			items: merged,
			total: existing ? existing.total + newItems : incoming.total
		}
	}

const createFieldPolicies = (field: string) =>
	({
		keyArgs: ['filter', 'sortAttribute', 'sortDirection'],
		read: readField(field),
		merge: mergeField(field)
	}) as any

const simpleRead = (existing: any[] = []) => {
	return existing
}

const simpleMerge = (existing: any[] = [], incoming: any[]) => {
	// Logger.log('simpleMerge', { existing, incoming })
	const merged = [...existing].filter(Boolean)
	incoming.forEach((record: any) => {
		if (!record) return
		const exists = merged.find(({ __ref }: any) => __ref === record?.__ref)
		!exists && merged.push(record)
	})
	return merged
}

const cache = new InMemoryCache({
	typePolicies: {
		Query: {
			fields: {
				listContent: createFieldPolicies('listContent'),
				listTaxonomies: createFieldPolicies('listTaxonomies'),
				listContentComponents: createFieldPolicies('listContentComponents'),
				listLocations: createFieldPolicies('listLocations'),
				listPetProfiles: createFieldPolicies('listPetProfiles'),
				listPlans: createFieldPolicies('listPlans'),
				listPaymentMethods: createFieldPolicies('listPaymentMethods')
			}
		},
		Content: {
			fields: {
				components: {
					read: simpleRead,
					merge: simpleMerge
				}
			}
		},
		ContentPage: {
			fields: {
				components: {
					read: simpleRead,
					merge: simpleMerge
				}
			}
		}
	}
})

export const getCacheId = (id: string | undefined, __typename: string = 'ContentComponent') => {
	return cache.identify({ id, __typename })
}

export const read = (id: string | undefined, type: string) => {
	const doc = getDoc(type)
	const name = variableToString({ [doc]: 'fragment' })
	// Logger.log('read', { id, type, name, doc })
	return cache.readFragment<any>({
		id,
		fragment: typeof doc === 'string' ? gql(doc) : doc,
		fragmentName: name
	})
}

export const list = (doc: any) => {
	return cache.readQuery<any>({
		query: typeof doc === 'string' ? gql(doc) : doc,
		variables: {}
	})
}

export const write = (id: string | undefined, data: any, type: string) => {
	const doc = getDoc(type)
	const name = variableToString({ [doc]: 'fragment' })
	return cache.writeFragment<any>({
		id,
		fragment: typeof doc === 'string' ? gql(doc) : doc,
		fragmentName: name,
		data
	})
}

export default cache
